import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { convertUrlToEmbedUrl } from '@social-embed/lib';

import { PARTNER_MATCHERS } from 'utils/partners';

import FieldDefault from 'components/field-default';

const matchPartner = url => {
    const partner = PARTNER_MATCHERS.find(partner => url.match(partner.regex));

    if (!partner) {
        return null;
    }

    return partner;
}

const EmbedInput = ({ value, small, autoFocus, withLabel, placeholder, changeOnBlur, onChange, onPartnerMatch, provideController }) => {
    const { t } = useTranslation(['embed', 'common']);

    const handleChange = useCallback(input => {
        if (!changeOnBlur) {
            onChange(input);
        }
    }, [changeOnBlur, onChange]);

    const handleBlur = useCallback(input => {
        if (changeOnBlur) {
            onChange(input);
        }
    }, [changeOnBlur, onChange]);

    const handleUrlPaste = useCallback(event => {
        const clipboardData = event.clipboardData || window.clipboardData;
        const pastedData = clipboardData.getData('Text');
        const iframeSrcMatch = pastedData.match(/<iframe.+src=(?:'|")(.+?)(?:'|")/);
        let embedUrl = pastedData;

        if (iframeSrcMatch && iframeSrcMatch[1]) {
            embedUrl = iframeSrcMatch[1];
        }

        const partner = matchPartner(embedUrl);

        if (partner) {
            event.preventDefault();
            onChange(partner.replacer(embedUrl));
            onPartnerMatch && onPartnerMatch(partner)
        } else {
            const parsedEmbedUrl = convertUrlToEmbedUrl(embedUrl) || embedUrl;
            if (parsedEmbedUrl && parsedEmbedUrl !== pastedData) {
                event.preventDefault();
                onChange(parsedEmbedUrl);
            }
        }
    }, [onChange, onPartnerMatch]);

    return <FieldDefault
        id="embed-input"
        value={value}
        small={small}
        autoFocus={autoFocus}
        label={ withLabel ? t('common:URL') : null }
        placeholder={ t('createURLPlaceholder') }
        onChange={handleChange}
        onBlur={handleBlur}
        onPaste={handleUrlPaste}
        provideController={provideController}
    />
}

export default EmbedInput;
